/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import MicrosoftLogin from 'react-microsoft-login';
import { MicrosoftIcon } from 'localResouces';
import ExternalLoginButtonContainer from './ExternalLoginButtonContainer';

const defaultButtonText = "Mit Microsoft anmelden";

export default function Login(props) {
  const { clientId, onSuccess, onFailure, disabled, buttonText } = props;

  const onSuccessHandler = (error, data, msal) => {
    if (error) {
      console.log("MICROSOFT LOGIN FAILURE", error);
      onFailure(error);
    }
    else {
      console.log("MICROSOFT LOGIN RESULT", data);
      onSuccess(data.idToken.rawIdToken);
    }
  };

  return (
    <ExternalLoginButtonContainer>
      <MicrosoftLogin
        clientId={clientId}
        authCallback={(e, d, m) => onSuccessHandler(e, d, m)}
        //debug={true}
      >
        <a target="_blank" className="msBtn" disabled={disabled}><button type="button" style={{ all: "unset", display: "contents" }} disabled={disabled}><img src={MicrosoftIcon} alt="" /><em>{buttonText || defaultButtonText}</em></button></a>
      </MicrosoftLogin>
    </ExternalLoginButtonContainer>
  );
}